import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import Card from "components/card/Card";
import { CustomerTypeBadge } from "../../CustomerTypeBadge";

interface CustomerInfoProps {
  customer: {
    name: string;
    email: string;
    userId?: string | number | null;
  };
}

export const CustomerInfo: React.FC<CustomerInfoProps> = ({ customer }) => {
  return (
    <Card p="0" width="fit-content">
      <Flex alignItems="center" gap="8px">
        <Text
          fontWeight="400"
          fontSize="12px"
          lineHeight="24px"
          color="#8E8C8C"
        >
          Customer
        </Text>
        <CustomerTypeBadge userId={customer?.userId} size="md" />
      </Flex>
      <Flex alignItems="center" marginTop="5px">
        <Flex direction="column">
          <Flex>
            <Text
              fontWeight="400"
              fontSize="12px"
              lineHeight="24px"
              color="#8E8C8C"
              ml="10px"
            >
              Name:
            </Text>
            <Text
              fontWeight="400"
              ml={1}
              fontSize={{ md: "17px", sm: "14px" }}
              lineHeight="135%"
              color="#000"
            >
              {customer?.name}
            </Text>
          </Flex>
          <Flex>
            <Text
              fontWeight="400"
              fontSize="12px"
              lineHeight="24px"
              color="#8E8C8C"
              ml="10px"
            >
              Email:
            </Text>
            <Text
              fontWeight="400"
              ml={1}
              fontSize={{ md: "17px", sm: "14px" }}
              lineHeight="135%"
              color="#000"
            >
              {customer?.email}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
